module.exports = __webpack_public_path__ + "static/media/logo-sm-light.a1abbf5f.png";